
<div 
    class="buttons" 
    [class.is-inline]="isInline"
    [class.is-block]="!isInline"
>
    <button (click)="editStart()"  *ngIf="!model.isEditing" [class.is-small]="isInline" [disabled]="isDisabled" class="button" [class.is-small]="isSmall">{{caption}}</button>
    <button (click)="editCancel()" *ngIf="model.isEditing"  [class.is-small]="isInline" [disabled]="model.isSaving || isDisabled" class="button" [class.is-small]="isSmall">Cancel</button>
    <button (click)="editSave()"   *ngIf="model.isEditing"  [class.is-small]="isInline" [disabled]="model.isSaving || isDisabled || isSaveDisabled" class="button is-success" [class.is-small]="isSmall">Save</button>
</div>